<script>
import axios from 'axios'
import adminTable from './mixins/adminTable'
import { mapGetterts, mapGetters } from 'vuex'
export default
{
    mixins: [ adminTable ],

    computed:
    {
        ...mapGetters({
            data: 'locationList',
        })
    },

    watch:
    {
        data()
        {
            this.updateData()
        },
    },

    methods:
    {
        fetch()
        {
            this.$store.dispatch('locationCheck')
            this.$nextTick(() => {
                this.updateData()
            })
        },

        afterUpdateModel(obj)
        {
            this.$store.dispatch('locationUpdate', obj).then(() =>{ this.fetch() })
        },

        afterDeleteModel(obj)
        {
            this.$store.dispatch('locationDelete', obj).then(() =>{ this.fetch() })
        },

        afterAddModel(obj)
        {
            this.$store.dispatch('locationNew', obj).then(() =>{ this.fetch() })
        },

    },

    data()
    {
        return {
            url: '/v1/admin/locations',
            tableName: 'tableLocations',
            emptyModel: { name: null, city_id: null, address: null, location: null, attachments: [], description: null, on_site: true, on_mobile: true, on_map: false, marker_x: 0, marker_y: 0, marker_direction: 'left', marker_icon: 'barna' },
            columns: [ 'id', 'name', 'name_en', 'city', 'address', 'location', 'created_at', 'updated_at', 'actions' ],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    name: this.$t('PLACE.NAME'),
                    name_en: this.$t('PROGRAM.NAME_EN'),
                    city: this.$t('PLACE.CITY'),
                    address: this.$t('PLACE.ADDRESS'),
                    location: this.$t('PLACE.LOCATION'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                    updated_at: this.$t('GENERAL.UPDATED_AT'),
                },
                columnsDisplay: { 'location': 'not_desktop', 'updated_at': 'not_desktop'  },
                perPage: 25,
                saveState: true,
                highlightMatches: true,
                filterByColumn: false,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['name', 'city', 'created_at', 'updated_at'],
            },
        }
    },


}
</script>

<template>
    <div class="container-fluid">
        <mv-modal ref="form">
            <span slot="header">{{ $t('PLACE.PLACE') }}</span>
            <mv-place-form :model="model" :edit="formEdit" @save="saveForm"></mv-place-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.PLACES') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newModel">
                            <icon name="plus"></icon>
                        </button>
                        <button class="btn btn-xs btn-success" @click="exportFile">
                            <icon name="download"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                    <div slot="city" slot-scope="props">
                        <div v-if="props.row.city_id && props.row.city">
                            {{ props.row.city.name }}
                        </div>
                    </div>
                    <div slot="location" slot-scope="props">
                        <div v-if="props.row.location && props.row.location.length == 2">
                            {{ props.row.location[0] }} , {{ props.row.location[1] }}
                        </div>
                    </div>
                    <div slot="child_row" slot-scope="props">
                        <div v-html="props.row.description">
                        </div>
                        <mv-attachment class="attachment-image" v-for="img in props.row.attachments" :key="img.id" :attachment="img">
                        </mv-attachment>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/Places.vue